import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-notification",
  standalone: true,
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
  imports: [CommonModule, TranslateModule],
})
export class NotificationComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<NotificationComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: any,
  ) {}

  protected closeDialog() {
    this.dialogRef.close();
  }

  protected continue() {
    this.dialogRef.close(true);
  }
}
